'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('faq-directory', {
      url: '/faq/:name',
      template: '<faq-list></faq-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/faq/list/faq-directory.routes.js